import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import React from "react";
import ButtonBar from "../../components/Buttons/ButtonBar";
import NewButton from "../../components/Buttons/NewButton";
import UploadButton from "../../components/Buttons/UploadButton";
import { Title } from "../../components/Desc";
import ProgressIndicator from "../../components/ProgressIndicator";
import BasicMenu from "../../components/menu/BasicMenu";
import strings from "../../config/localization";
import { useGetResourcesQuery } from "../../services/appln";
import { doesPermissionExist } from "../util";
import DeleteResource from "./DeleteResource";
import EditResource from "./EditResource";
import NewResource from "./NewResource";
import UploadResources from "./UploadResources";

interface Resource {
  id: string;
  name: string;
  desc: string;
}

export default function ListResources() {
  const resourcesQueryResponse = useGetResourcesQuery();

  const [newDialogOpen, setNewDialogOpen] = React.useState(false);
  const [uploadDialogOpen, setUploadDialogOpen] = React.useState(false);

  const columns: ColumnsType<Resource> = [
    {
      title: strings.extSerialNo,
      dataIndex: "externalSerialNo",
      key: "externalSerialNo",
      width: 5,
    },
    {
      title: strings.resourceType,
      dataIndex: "resourceTypeName",
      key: "resourceTypeName",
      width: 5,
    },
    {
      title: strings.organization,
      dataIndex: "organizationName",
      key: "organizationName",
      width: 5,
    },
    {
      title: "",
      dataIndex: "edit",
      key: "edit",
      width: 2,
      render: (text, record, index) =>
        doesPermissionExist("update-resource") && (
          <EditResource id={record.id} initialValues={record} />
        ),
    },
    {
      title: "",
      dataIndex: "delete",
      key: "delete",
      width: 2,
      render: (text, record, index) =>
        doesPermissionExist("delete-resource") && (
          <DeleteResource id={record.id} />
        ),
    },
  ];

  console.log("ResourceList, resourcesQueryResponse:", resourcesQueryResponse);

  return (
    <Box>
      {(resourcesQueryResponse.isLoading ||
        resourcesQueryResponse.isFetching) && <ProgressIndicator />}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title text={strings.resources}></Title>
        </Grid>
        <Grid item xs={12}>
          <ButtonBar>
            <NewButton
              onClickHandler={() => {
                setNewDialogOpen(true);
              }}
            />
            <NewResource
              onSubmitHandler={(newObj: any) => {
                console.log("onSubmitHandler, newObj:", newObj);
                setNewDialogOpen(false);
              }}
              onCancelHandler={() => {
                console.log("onCancelHandler");
                setNewDialogOpen(false);
              }}
              state={newDialogOpen}
            />
            <UploadButton
              onClickHandler={() => {
                setUploadDialogOpen(true);
              }}
            />
            <UploadResources
              state={uploadDialogOpen}
              onSubmitHandler={(newObj: any) => {
                console.log("onSubmitHandler, newObj:", newObj);
                setUploadDialogOpen(false);
              }}
              onCancelHandler={() => {
                console.log("onCancelHandler");
                setUploadDialogOpen(false);
              }}
            />
          </ButtonBar>
        </Grid>
        <Grid item xs={12}>
          <Table
            virtual
            scroll={{ y: 600 }}
            columns={columns}
            dataSource={resourcesQueryResponse.data?.data}
            pagination={false}
            rowKey="id"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
